import {
  ComponentFilter,
  ProductGroupFilter,
  SizeFilter,
  StyleFilter,
} from "@globalTypes"

export type FilterAction =
  | { type: "set-initial-state"; state: FilterState }
  | { type: "set-initial-filter-state"; state: FilterState }
  | { type: "set-initial-search-state"; state: FilterState }
  | { type: "set-initial-value"; value: string }
  | { type: "set-size-filter"; size: SizeFilter }
  | {
      type: "set-product_group-filter"
      productGroup: ProductGroupFilter & Omit<ComponentFilter, "fixed">
    }
  | { type: "set-style-filter"; style: StyleFilter }
  | { type: "set-query"; query: string | null }
  | { type: "increase-hits-per-page" }
  | { type: "clear" }

export type ProductGroup =
  | (ProductGroupFilter & Omit<ComponentFilter, "fixed">)
  | null
export type FilterState = {
  size: SizeFilter | null
  productGroup: ProductGroup
  style: StyleFilter | null
  query: string | null
  hitsPerPage: number
  initialValue: string
  initiated: boolean
}

export const initialState: FilterState = {
  size: null,
  productGroup: null,
  style: null,
  query: "",
  hitsPerPage: 15,
  initialValue: "",
  initiated: false,
}

export function reducer(state: FilterState, action: FilterAction): FilterState {
  switch (action.type) {
    case "set-initial-value": {
      return { ...state, initialValue: action.value, initiated: true }
    }
    case "set-initial-state": {
      return { ...state, ...action.state }
    }
    case "set-product_group-filter":
      return {
        ...state,
        hitsPerPage: 15,
        productGroup: action.productGroup,
        size: null,
        style: null,
      }
    case "set-size-filter":
      return { ...state, hitsPerPage: 15, size: action.size }
    case "set-style-filter":
      return { ...state, hitsPerPage: 15, style: action.style }
    case "set-query":
      return { ...state, query: action.query, hitsPerPage: 15 }
    case "increase-hits-per-page":
      return { ...state, hitsPerPage: state.hitsPerPage + 15 }
    case "clear":
      return {
        ...state,
        hitsPerPage: 15,
        size: null,
        productGroup: null,
        style: null,
      }
    default:
      return state
  }
}
